import axios from "axios";
import Config from "@/config"

export default class PaymentService {
  getPlans(accesstoken) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/pay_get_plans.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("account") + "/plans",
        options
      )
      .then(res => res.data);
  }
  getInvoices(accesstoken) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/pay_get_invoices.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("account") + "/billing",
        options
      )
      .then(res => res.data);
  }
  createSessionSingle(accesstoken, items, currency, type, extra) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/pay_post_createSession.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    let data = {
      items: items,
      currency: currency,
      businessType: type,
      businessExtra: extra
    }
    return axios
      .post(
        Config.proxy + Config.url("account") + "/checkout/create-single-payment-session", data,
        options
      )
      .then(res => res.data);
  }

}
